import { Link } from '@joehua/react-link';
import cn from 'classnames';
import * as React from 'react';
import { themr } from 'react-css-themr';
import * as url from 'url';
import AppConfig from '../AppConfig';
import { JsonLd } from '../JsonLd';
import { routeToString } from '../utils/route';
const DumpBreadcrumbs = ({ items, separator = '»', theme = {}, }) => {
    return (React.createElement(AppConfig, null, ({ rootUrl, routesMap }) => {
        const jsonld = {
            '@context': 'http://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: items
                .map((item, idx) => {
                const path = item.to
                    ? routeToString(item.to, routesMap)
                    : item.href;
                if (!path) {
                    return null;
                }
                return {
                    '@type': 'ListItem',
                    position: idx + 1,
                    item: {
                        '@id': rootUrl ? url.resolve(rootUrl, path) : path,
                        name: item.label,
                    },
                };
            })
                .filter(Boolean),
        };
        return (React.createElement("div", { className: theme.root },
            items.reduce((acc, item, idx) => {
                const link = !item.disableLink ? (React.createElement(Link, { key: idx, className: cn(theme.item, theme.link), to: item.to }, item.label)) : (React.createElement("span", { key: idx, className: theme.item }, item.label));
                return [
                    ...acc,
                    link,
                    idx < items.length - 1 && (React.createElement("span", { key: `separator-${idx}`, className: theme.separator }, separator)),
                ];
            }, []),
            React.createElement(JsonLd, { object: jsonld })));
    }));
};
export const defaultBreadcrumbsTheme = {
    root: '',
    item: 'f6 fw4',
    link: 'silver hover-pc',
    separator: 'mh2',
};
const Breadcrumbs = themr('Breadcrumbs', {}, {
    composeTheme: 'softly',
})(DumpBreadcrumbs);
export default Breadcrumbs;
//# sourceMappingURL=index.js.map